<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    props: {
        items: {
            required: true,
            type: String
        }
    },
    components: {
        Carousel, Slide
    },
    data() {
        return {
            itemsParsed: JSON.parse(this.items)
        }
    }
}
</script>
<template lang="pug">
    carousel.quiz-slider(
        :perPage="1"
        :navigationEnabled="true"
        :paginationEnabled="false"
    )
        slide(
            v-for="(item, index) in itemsParsed"
            :key="index"
        )
            h1 {{ item.heading }}
            .content(v-html="item.content")
</template>